import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Caracteristicas } from "../interfaces/Caracteristicas";
import { CaracteristicasApto } from "../interfaces/CaracteristicasApto";
import { CaracteristicasEmprendimento } from "../interfaces/CaracteristicasEmprendimento";

export type EscopoCaracteristica = "EMPREENDIMENTO" | "APARTAMENTO";

type VinculoCaracteristica = CaracteristicasApto | CaracteristicasEmprendimento;

type BuscarCaracteristicasResponse = {
  caracteristicas: Caracteristicas[];
  vinculadas: VinculoCaracteristica[];
};

export const buscarCaracteristicasService = async (
  escopo: EscopoCaracteristica,
  referenciaId?: number | null
): Promise<BuscarCaracteristicasResponse> => {
  const Token = validateToken();
  const headers = Token ? { Authorization: Token.AuthStr } : undefined;
  const urlCaracteristicas = `${Globais.DOMINIOBACK}/caracteristicas`;
  const urlVinculos =
    escopo === "APARTAMENTO"
      ? `${Globais.DOMINIOBACK}/caracteristicas-apto/${referenciaId}`
      : `${Globais.DOMINIOBACK}/caracteristicas-empreendimento/${referenciaId}`;

  try {
    const requests: Promise<any>[] = [
      axios.get(urlCaracteristicas, {
        params: { escopo },
        headers,
      }),
    ];

    if (referenciaId) {
      requests.push(
        axios.get(urlVinculos, {
          headers,
        })
      );
    }

    const [responseCaracteristicas, responseVinculos] = await Promise.all(
      requests
    );

    const caracteristicas = (
      (responseCaracteristicas?.data as Caracteristicas[]) || []
    ).filter((item) => item.escopo === escopo || item.escopo === "AMBOS");

    const vinculadas =
      (responseVinculos?.data as VinculoCaracteristica[] | undefined) || [];

    const caracteristicasPorId = new Map<number, Caracteristicas>();

    caracteristicas.forEach((item) => {
      caracteristicasPorId.set(item.id, item);
    });

    vinculadas.forEach((item) => {
      if (item.Caracteristicas?.id) {
        caracteristicasPorId.set(item.Caracteristicas.id, item.Caracteristicas);
      }
    });

    return {
      caracteristicas: caracteristicas.map((item) => ({
        ...item,
        nome: caracteristicasPorId.get(item.id)?.nome || item.nome,
      })),
      vinculadas: vinculadas.map((item) => ({
        ...item,
        Caracteristicas:
          item.Caracteristicas || caracteristicasPorId.get(item.caracteristicaId),
      })),
    };
  } catch (error) {
    console.error(error);
    return {
      caracteristicas: [],
      vinculadas: [],
    };
  }
};
